module.exports = __webpack_public_path__ + "img/Group-16991.55df5dc1.svg";